import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  /* Layout */
  html, body {
    overflow: hidden;
  }
`;
